import { Title } from "@/components/ui/Title";
import { useIsTabletOrBigger, useStyles } from "@/styles/useStyles";
import { Space, Stack } from "@mantine/core";

export function UserRecs() {
  const { theme, ...styles } = useStyles();
  const isTabletOrBigger = useIsTabletOrBigger();

  return (
    <Stack
      pt={styles.dimensions.headerHeight + (isTabletOrBigger ? 0 : 0)}
      pb={200}
      px={isTabletOrBigger ? "xl" : 0}
      h="100%"
      mih="100vh"
      w="100%"
      bg={theme.colors.background[1]}
      align="center"
    >
      <Space h="md" />
      <Title order={1} size="h2" c="primary.9">
        My Career Profile and Suggestions
      </Title>
    </Stack>
  );
}
